import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RecipeService } from '../recipe.service';
import { Recipe } from '../recipe.model';

@Component({
    selector: 'app-recipe-detail',
    templateUrl: './recipe-detail.component.html',
    styleUrls: ['./recipe-detail.component.scss'],
    standalone: false
})
export class RecipeDetailComponent implements OnInit, OnDestroy {
  recipe: Recipe | null = null;
  loading = true;
  showFormModal = false;

  private sub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private recipeService: RecipeService
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id')!;
    this.sub = this.recipeService.getRecipeById(id).subscribe(recipe => {
      this.recipe = recipe;
      this.loading = false;
      if (!recipe) this.router.navigate(['/recipe']);
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  openEditModal() {
    this.showFormModal = true;
  }

  onFormSaved() {
    this.showFormModal = false;
  }

  onFormCancelled() {
    this.showFormModal = false;
  }

  deleteRecipe() {
    if (!this.recipe) return;
    if (confirm(`Delete "${this.recipe.name}"?`)) {
      this.recipeService.deleteRecipe(this.recipe.id).then(() => {
        this.router.navigate(['/recipe']);
      }).catch(() => {
        alert('Failed to delete. Please try again.');
      });
    }
  }

  goBack() {
    this.router.navigate(['/recipe']);
  }
}
